/*global $*/
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
import firebase from "firebase/app";
import { ToastContainer, toast } from "react-toastify";

import { useState } from "react";
import { BrowserRouter, Switch, Route, Redirect } from "react-router-dom";

import "./App.css?v=0.0.2";
import SignUp from "./Modules/myBooks/SignUp?v=0.0.2";
import BusinessDetailsWiz from "./Modules/myBooks/BusinessDetailsWiz?v=0.0.2";
import Login from "./Modules/myBooks/Login?v=0.0.2";
import ForgotPassword from "./Modules/myBooks/ForgotPassword?v=0.0.2";
import Resetuserpassword from "./Modules/myBooks/Resetuserpassword?v=0.0.2";
import AccountDelete from "./Modules/myBooks/AccountDelete?v=0.0.2";
import AccountActivation from "./Modules/myBooks/AccountActivation?v=0.0.2";
import InvitedUserPassword from "./Modules/myBooks/InvitedUserPassword?v=0.0.2";
import AccountActivateNotification from "./Modules/myBooks/AccountActivateNotification?v=0.0.2";
import EstimateReview from "./Modules/myBooks/EstimateReview?v=0.0.2";
import ApplicationAccessApproval from "./Modules/myBooks/ApplicationAccessApproval?v=0.0.2";
import SignUpMyPlan from "./Modules/myPlan/SignUp?v=0.0.2";
import BusinessDetailsWizMyPlan from "./Modules/myPlan/BusinessDetailsWiz?v=0.0.2";
import LoginMyPlan from "./Modules/myPlan/Login?v=0.0.2";
import ForgotPasswordMyPlan from "./Modules/myPlan/ForgotPassword?v=0.0.2";
import ResetuserpasswordMyPlan from "./Modules/myPlan/Resetuserpassword?v=0.0.2";
import InvitedUserPasswordMyPlan from "./Modules/myPlan/InvitedUserPassword?v=0.0.2";
import AccountDeleteMyPlan from "./Modules/myPlan/AccountDelete?v=0.0.2";
import AccountActivationMyPlan from "./Modules/myPlan/AccountActivation?v=0.0.2";

import * as Constants from "./Constants?v=0.0.2";

import environment from "./Environment/app.environment-prodind.json?v=0.0.2";

function App() {
  var link = document.querySelector("link[rel~='icon']");
  if (!link) {
    link = document.createElement("link");
    link.rel = "icon";
    document.getElementsByTagName("head")[0].appendChild(link);
  }
  if (window.location.href.indexOf("myBooks") > -1) {
    link.href =
      "https://cdn.zetran.com/assets-accounts/images/myBooks/favicon/favicon.ico";
  } else if (window.location.href.indexOf("myPlan") > -1) {
    link.href =
      "https://cdn.zetran.com/assets-mybooks/accounts-portal/myPlanFavicon.ico";
  }
  const firebaseConfig = {
    apiKey: "AIzaSyCngI5SXs9YpvqfRA8qR-YxzXVh5QsraKM",
    authDomain: "mybooksandroid.firebaseapp.com",
    databaseURL: "https://mybooksandroid.firebaseio.com",
    projectId: "mybooksandroid",
    storageBucket: "mybooksandroid.appspot.com",
    messagingSenderId: "470361136010",
    appId: "1:470361136010:web:754192dcd5239a28930673",
    measurementId: "G-BE7S5LR2PR",
  };
  if (!firebase.apps.length) {
    firebase.initializeApp(firebaseConfig);
  } else {
    firebase.app();
  }

  // useEffect(() => {
  //   const oneTapSignedIn = (response) => {
  //     set_id_one_tap(response.credential);
  //   };
  //   if (
  //     window.location.href.indexOf("signup") > -1 ||
  //     window.location.href.indexOf("login") > -1
  //   ) {
  //     google.accounts.id.initialize({
  //       client_id:
  //         "891756357354-nes8ss4p9q49mn0026abu8is6em8uova.apps.googleusercontent.com",
  //       callback: oneTapSignedIn,
  //     });
  //     google.accounts.id.prompt((notification) => {});
  //   }
  // }, []);

  const [stage, setStage] = useState(1);
  const [message, setMessage] = useState("");
  const [signUpSuccess, setSignUpSuccess] = useState(false);
  const [showSignUpLoader, setShowSignUpLoader] = useState(false);
  const [showLoginLoader, setShowLoginLoader] = useState(false);
  const [requiredEmail, setRequiredEmail] = useState("");
  const [signUpPayload, setSignUpPayload] = useState({ session_id: "" });
  const [otpVerifiedSuccessfully, setOtpVerifiedSuccessfully] = useState(false);
  const [loginResponse, setLoginResponse] = useState({
    responseInvalid: false,
    responseInvalidMessage: "",
  });
  const [showLoader, setShowLoader] = useState(false);
  const [id_one_tap, set_id_one_tap] = useState("");
  const [signUpData, setSignUpData] = useState({
    User: {
      username: "",
      usernametype: "",
      password: "",
      socialLogin: false,
      socialLoginVia: "",
      otp: "",
      phoneNumber: "",
      phoneNumberCode: "+91",
    },
    Organization: {
      timeZone: "",
      baseCountry: "",
      country_txt: "",
      fiscalYear: "",
      currencyId: "",
      dateFormat: "",
      companyname: "",
      orgPhoneNumber: "",
      industryType: "",
      legalName: "",
      multiOrganizationFlag: false,
      curr_sym: "",
      device_type: "",
      subscriptionType: "",
      source_page: "",
    },
  });

  const showToast = (text) => {
    toast(text, {
      position: "top-center",
      autoClose: 8000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
    });
  };

  const showSuccessToast = (text) => {
    toast.success(text, {
      position: "top-center",
      autoClose: 8000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
    });
  };

  const showFailureToast = (text) => {
    toast.error(text, {
      position: "top-center",
      autoClose: 8000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "dark",
    });
  };

  const clearData = () => {
    setSignUpData({
      User: {
        username: "",
        usernametype: "",
        password: "",
        socialLogin: false,
        socialLoginVia: "",
        otp: "",
        phoneNumber: "",
        phoneNumberCode: "+91",
      },
      Organization: {
        timeZone: "",
        baseCountry: "",
        country_txt: "",
        fiscalYear: "",
        currencyId: "",
        dateFormat: "",
        companyname: "",
        orgPhoneNumber: "",
        industryType: "",
        legalName: "",
        multiOrganizationFlag: false,
        curr_sym: "",
        device_type: "",
        subscriptionType: "",
        source_page: "",
      },
    });
    setShowLoader(false);
    set_id_one_tap("");
    setStage(1);
    setMessage("");
    setSignUpSuccess(false);
    setShowSignUpLoader(false);
    setShowLoginLoader(false);
    setRequiredEmail("");
    setSignUpPayload({ session_id: "" });
    setLoginResponse({
      responseInvalid: false,
      responseInvalidMessage: "",
    });
    setOtpVerifiedSuccessfully(false);
  };

  const SignUpHandler = (obj) => {
    setSignUpData((prevState) => {
      return { ...prevState, ...obj };
    });
    if (signUpData.Organization.country_txt === "") {
      setCurrencyCountryFinancialYear(obj);
    } else if (
      (obj.User.usernametype === "phoneNumber" && obj.User.otp !== "") ||
      obj.User.usernametype === "email"
    ) {
      onNextHandler();
    }
  };

  const SetOrganisationData = (obj) => {
    setSignUpData((prevState) => {
      if (prevState.User.socialLogin === true) {
        return {
          ...prevState,
          User: {
            username: "",
            usernametype: "",
            password: "",
            socialLogin: false,
            socialLoginVia: "",
            otp: "",
            phoneNumber: "",
            phoneNumberCode: "+91",
          },
          ...obj,
        };
      } else {
        return { ...prevState, ...obj };
      }
    });
  };

  const BusinessWizardHandler = (obj) => {
    setShowSignUpLoader(true);
    if (obj.Organization.country_txt === "India") {
      fetch(environment.indLoginAppAPI + Constants.saveUserOrganizationInfo, {
        method: "POST",
        body: JSON.stringify({ ...signUpData, ...obj }),
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((res) => res.json())
        .then(
          (result) => {
            setShowSignUpLoader(false);
            if (result.dataStatus.isSuccess) {
              setSignUpSuccess(true);
              setSignUpPayload(result.payload);
            } else {
              setSignUpSuccess(false);
              setSignUpPayload({ session_id: "" });
              setMessage(result.dataStatus.message);
            }
          },
          (error) => {
            console.log(error);
          }
        );
    } else {
      fetch(
        environment.globalLoginAppAPI + Constants.saveUserOrganizationInfo,
        {
          method: "POST",
          body: JSON.stringify({ ...signUpData, ...obj }),
          headers: {
            "Content-Type": "application/json",
          },
        }
      )
        .then((res) => res.json())
        .then(
          (result) => {
            setShowSignUpLoader(false);
            if (result.dataStatus.isSuccess) {
              setSignUpSuccess(true);
              setSignUpPayload(result.payload);
            } else {
              setSignUpSuccess(false);
              setSignUpPayload({ session_id: "" });
              setMessage(result.dataStatus.message);
            }
          },
          (error) => {
            console.log(error);
          }
        );
    }
    setSignUpData((prevState) => {
      return { ...prevState, ...obj };
    });
  };

  const BusinessWizardHandlerMyPlan = (obj) => {
    setShowSignUpLoader(true);
    fetch(environment.myPlanLoginAppAPI + Constants.saveUserOrganizationInfo, {
      method: "POST",
      body: JSON.stringify({
        Organization: {
          baseCountry: obj.Organization.baseCountry,
          business_name: obj.Organization.companyname,
          country: obj.Organization.country_txt,
          country_txt: "",
          curr_sym: obj.Organization.curr_sym,
          currency_id: obj.Organization.currencyId,
          date_format: obj.Organization.dateFormat,
          device_type: obj.Organization.device_type,
          fiscal_year: obj.Organization.fiscalYear,
          industry_type: obj.Organization.industryType,
          multiOrganizationFlag: obj.Organization.multiOrganizationFlag,
          ownership_type: "Premium",
          time_zone: obj.Organization.timeZone,
        },
        User: {
          ...signUpData.User,
          emailAddress: signUpData.User.username,
        },
      }),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then(
        (result) => {
          setShowSignUpLoader(false);
          if (result.dataStatus.isSuccess) {
            setSignUpSuccess(true);
            setSignUpPayload(result.payload);
          } else {
            setSignUpSuccess(false);
            setSignUpPayload({ session_id: "" });
            setMessage(result.dataStatus.message);
          }
        },
        (error) => {
          console.log(error);
        }
      );
    setSignUpData((prevState) => {
      return { ...prevState, ...obj };
    });
  };

  const redirect_Sign_Up = (acc_type) => {
    if (
      signUpData.User.username === "sup.user@zetran.com" ||
      signUpData.User.username === "sup.user@zetran.in"
    ) {
      let sessionId = signUpPayload.session_id;
      let encodedUserName = encodeURIComponent(signUpData.User.username);
      let encodedPassword = encodeURIComponent(signUpData.User.password);
      let validApplicationURL =
        (signUpData.Organization.country_txt === "India"
          ? environment.indmyBooksAppUrl
          : environment.globalmyBooksAppUrl) +
        "?au=" +
        sessionId +
        "&username=" +
        encodedUserName +
        "&password=" +
        encodedPassword +
        "&account_type=" +
        acc_type;
      window.location.href = validApplicationURL;
    } else {
      let sessionId = signUpPayload.session_id;
      let validApplicationURL =
        (signUpData.Organization.country_txt === "India"
          ? environment.indmyBooksAppUrl
          : environment.globalmyBooksAppUrl) +
        "?au=" +
        sessionId +
        "&account_type=" +
        acc_type;
      window.location.href = validApplicationURL;
    }
  };

  const redirect_Sign_Up_myPlan = (acc_type) => {
    let sessionId = signUpPayload.session_id;
    let encodedUserName = encodeURIComponent(signUpData.User.username);
    let encodedPassword = encodeURIComponent(signUpData.User.password);
    if (signUpData.User.username === "support@zetran.com") {
      let validApplicationURL =
        environment.myPlanAppUrl +
        "?au=" +
        sessionId +
        "&username=" +
        encodedUserName +
        "&password=" +
        encodedPassword +
        "&account_type=" +
        acc_type;
      window.location.href = validApplicationURL;
    } else {
      let sessionId = signUpPayload.session_id;
      let validApplicationURL =
        environment.myPlanAppUrl +
        "?au=" +
        sessionId +
        "&email=" +
        encodedUserName +
        "&account_type=" +
        acc_type;
      window.location.href = validApplicationURL;
    }
  };

  const loginAppAPI = (loginURL, obj, myBooksUrl) => {
    fetch(loginURL + Constants.login, {
      method: "POST",
      body: Constants.CreateData(obj.User),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    })
      .then((res) => res.json())
      .then(
        (result) => {
          if (result.dataStatus.isSuccess) {
            if (
              obj.User.username === "sup.user@zetran.com" ||
              obj.User.username === "sup.user@zetran.in"
            ) {
              let sessionId = result.payload.session_id;
              let encodedUserName = encodeURIComponent(obj.User.username);
              let encodedPassword = encodeURIComponent(obj.User.password);
              let validApplicationURL =
                myBooksUrl +
                "?au=" +
                sessionId +
                "&username=" +
                encodedUserName +
                "&password=" +
                encodedPassword;
              window.location.href = validApplicationURL;
            } else {
              let sessionId = result.payload.session_id;
              let validApplicationURL = myBooksUrl + "?au=" + sessionId;
              window.location.href = validApplicationURL;
            }
          } else {
            setLoginResponse({
              responseInvalid: true,
              responseInvalidMessage: result.dataStatus.message,
            });
            setShowLoginLoader(false);
          }
        },
        (error) => {
          console.log(error);
        }
      );
  };

  const signInHandler = (obj) => {
    setShowLoginLoader(true);
    fetch(environment.loginAppAPI + Constants.loginUrlCheck, {
      method: "POST",
      body: JSON.stringify(obj),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then(
        (result) => {
          if (result.dataStatus.isSuccess) {
            loginAppAPI(
              result.payload === "india"
                ? environment.indLoginAppAPI
                : environment.globalLoginAppAPI,
              obj,
              result.payload === "india"
                ? environment.indmyBooksAppUrl
                : environment.globalmyBooksAppUrl
            );
          } else {
            setShowLoginLoader(false);
            setLoginResponse({
              responseInvalid: true,
              responseInvalidMessage: result.dataStatus.message,
            });
          }
        },
        (error) => {
          console.log(error);
        }
      );
  };

  const setCurrencyCountryFinancialYear = async (obj) => {
    setShowLoader(true);
    await $.ajax({
      url: "https://geolocation-db.com/jsonp",
      jsonpCallback: "callback",
      dataType: "jsonp",
      success: function (response) {
        let baseCountry = "";
        if (response) {
          baseCountry = response.country_code;
        } else {
          baseCountry = "USA";
        }
        switch (baseCountry) {
          case "IN":
            if (baseCountry === environment.baseCountry) {
              setSignUpData((prevState) => {
                return {
                  ...prevState,
                  Organization: {
                    country_txt: "India",
                    fiscalYear: "April-March",
                    currencyId: "INR-India Rupee",
                    dateFormat: "dd-MM-yyyy",
                    timeZone: "",
                    baseCountry: "",
                    companyname: "",
                    orgPhoneNumber: "",
                    industryType: "",
                    legalName: "",
                    multiOrganizationFlag: false,
                    curr_sym: "",
                    device_type: "",
                    subscriptionType: "",
                    source_page: "",
                  },
                };
              });
            } else if (environment.baseCountry === "USA") {
              if (baseCountry === "IN") {
                setSignUpData((prevState) => {
                  return {
                    ...prevState,
                    Organization: {
                      country_txt: "India",
                      fiscalYear: "April-March",
                      currencyId: "INR-India Rupee",
                      dateFormat: "dd-MM-yyyy",
                      timeZone: "",
                      baseCountry: "",
                      companyname: "",
                      orgPhoneNumber: "",
                      industryType: "",
                      legalName: "",
                      multiOrganizationFlag: false,
                      curr_sym: "",
                      device_type: "",
                      subscriptionType: "",
                      source_page: "",
                    },
                  };
                });
              } else {
                setSignUpData((prevState) => {
                  return {
                    ...prevState,
                    Organization: {
                      country_txt: "United States Of America (USA)",
                      fiscalYear: "January-December",
                      currencyId: "USD-United States Dollar",
                      dateFormat: "MM-dd-yyyy",
                      timeZone: "",
                      baseCountry: "",
                      companyname: "",
                      orgPhoneNumber: "",
                      industryType: "",
                      legalName: "",
                      multiOrganizationFlag: false,
                      curr_sym: "",
                      device_type: "",
                      subscriptionType: "",
                      source_page: "",
                    },
                  };
                });
              }
            }
            break;
          case "USA":
            if (baseCountry === environment.baseCountry) {
              setSignUpData((prevState) => {
                return {
                  ...prevState,
                  Organization: {
                    country_txt: "United States Of America (USA)",
                    fiscalYear: "January-December",
                    currencyId: "USD-United States Dollar",
                    dateFormat: "MM-dd-yyyy",
                    timeZone: "",
                    baseCountry: "",
                    companyname: "",
                    orgPhoneNumber: "",
                    industryType: "",
                    legalName: "",
                    multiOrganizationFlag: false,
                    curr_sym: "",
                    device_type: "",
                    subscriptionType: "",
                    source_page: "",
                  },
                };
              });
            } else if (environment.baseCountry === "IN") {
              if (baseCountry === "IN") {
                setSignUpData((prevState) => {
                  return {
                    ...prevState,
                    Organization: {
                      country_txt: "India",
                      fiscalYear: "April-March",
                      currencyId: "INR-India Rupee",
                      dateFormat: "dd-MM-yyyy",
                      timeZone: "",
                      baseCountry: "",
                      companyname: "",
                      orgPhoneNumber: "",
                      industryType: "",
                      legalName: "",
                      multiOrganizationFlag: false,
                      curr_sym: "",
                      device_type: "",
                      subscriptionType: "",
                      source_page: "",
                    },
                  };
                });
              } else {
                setSignUpData((prevState) => {
                  return {
                    ...prevState,
                    Organization: {
                      country_txt: "United States Of America (USA)",
                      fiscalYear: "January-December",
                      currencyId: "USD-United States Dollar",
                      dateFormat: "MM-dd-yyyy",
                      timeZone: "",
                      baseCountry: "",
                      companyname: "",
                      orgPhoneNumber: "",
                      industryType: "",
                      legalName: "",
                      multiOrganizationFlag: false,
                      curr_sym: "",
                      device_type: "",
                      subscriptionType: "",
                      source_page: "",
                    },
                  };
                });
              }
            }
            break;
          default:
            break;
        }
        setShowLoader(false);
        if (
          (obj.User.usernametype === "phoneNumber" && obj.User.otp !== "") ||
          obj.User.usernametype === "email"
        ) {
          navigateToBusinessDetailsScreen();
        }
      },
      error: function (response) {
        setShowLoader(false);
        if (
          (obj.User.usernametype === "phoneNumber" && obj.User.otp !== "") ||
          obj.User.usernametype === "email"
        ) {
          navigateToBusinessDetailsScreen();
        }
        console.log(response);
      },
    });
  };

  const navigateToBusinessDetailsScreen = () => {
    onNextHandler();
  };

  const signInHandlerMyPlan = (obj, link) => {
    setShowLoginLoader(true);
    fetch(environment.myPlanLoginAppAPI + link, {
      method: "POST",
      body: JSON.stringify(obj),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then(
        (result) => {
          setShowLoginLoader(false);
          if (result.dataStatus.isSuccess) {
            let sessionId = result.payload.session_id;
            let encodedUserName = encodeURIComponent(obj.emailAddress);
            let encodedPassword = encodeURIComponent(obj.password);
            if (signUpData.User.username === "support@zetran.com") {
              let validApplicationURL =
                environment.myPlanAppUrl +
                "?au=" +
                sessionId +
                "&username=" +
                encodedUserName +
                "&password=" +
                encodedPassword;
              window.location.href = validApplicationURL;
            } else {
              let validApplicationURL =
                environment.myPlanAppUrl +
                "?au=" +
                sessionId +
                "&email=" +
                encodedUserName;
              window.location.href = validApplicationURL;
            }
          } else {
            setLoginResponse({
              responseInvalid: true,
              responseInvalidMessage: result.dataStatus.message,
            });
            setShowLoginLoader(false);
          }
        },
        (error) => {
          console.log(error);
        }
      );
  };

  const onPrevHandler = () => {
    setStage(1);
  };

  const onNextHandler = () => {
    setStage(2);
  };

  return (
    <>
      <ToastContainer
        position="top-center"
        autoClose={6000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
      <BrowserRouter>
        <Switch>
          <Route path="/myBooks/signup">
            {stage === 1 && (
              <SignUp
                environment={environment}
                id_one_tap={id_one_tap}
                onNext={onNextHandler}
                onDone={SignUpHandler}
                showToast={showToast}
                showLoader={showLoader}
                socialLogin={signUpData.socialLogin}
                email={signUpData.User.username}
                password={signUpData.User.password}
                validEmail={signUpData.User.username === "" ? false : true}
                validPassword={signUpData.User.password === "" ? false : true}
                clearData={clearData}
                User={signUpData.User}
                responseInvalidMessage={loginResponse.responseInvalidMessage}
                clearResponseData={() => {
                  setLoginResponse({
                    responseInvalid: false,
                    responseInvalidMessage: "",
                  });
                }}
                otpVerifiedSuccessfully={otpVerifiedSuccessfully}
                setOtpVerifiedSuccessfully={(flag) => {
                  setOtpVerifiedSuccessfully(flag);
                }}
              ></SignUp>
            )}
            {stage === 2 && (
              <BusinessDetailsWiz
                clearFailMessage={() => {
                  setMessage("");
                }}
                Organization={signUpData.Organization}
                SetOrganisationData={SetOrganisationData}
                environment={environment}
                showLoader={showSignUpLoader}
                session_id={signUpPayload.session_id}
                redirect={redirect_Sign_Up}
                signUpSuccess={signUpSuccess}
                username={signUpData.User.username}
                password={signUpData.User.password}
                onPrev={onPrevHandler}
                onDone={BusinessWizardHandler}
                failMessage={message}
              ></BusinessDetailsWiz>
            )}
          </Route>
          <Route path="/myBooks/login">
            <Login
              showLoader={showLoginLoader}
              environment={environment}
              id_one_tap={id_one_tap}
              signIn={signInHandler}
              onNext={onNextHandler}
              onDone={SignUpHandler}
              socialLogin={signUpData.User.socialLogin}
              responseInvalid={loginResponse.responseInvalid}
              responseInvalidMessage={loginResponse.responseInvalidMessage}
              setFalse={() => {
                setLoginResponse({
                  responseInvalid: false,
                  responseInvalidMessage: "",
                });
              }}
              email={signUpData.User.username}
              password={signUpData.User.password}
              clearData={clearData}
            ></Login>
          </Route>
          <Route path="/myBooks/forgotpassword">
            <ForgotPassword
              environment={environment}
              showToast={showSuccessToast}
            ></ForgotPassword>
          </Route>
          <Route path="/myBooks/resetuserpassword">
            <Resetuserpassword
              environment={environment}
              showSuccessToast={showSuccessToast}
              showFailureToast={showFailureToast}
            ></Resetuserpassword>
          </Route>
          <Route path="/myBooks/accountdelete">
            <AccountDelete environment={environment}></AccountDelete>
          </Route>
          <Route path="/myBooks/accountactivation">
            <AccountActivation environment={environment}></AccountActivation>
          </Route>
          <Route path="/myBooks/inviteduserpassword">
            <InvitedUserPassword
              environment={environment}
              showSuccessToast={showSuccessToast}
              showFailureToast={showFailureToast}
            ></InvitedUserPassword>
          </Route>
          <Route path="/myBooks/accountactivatenotification">
            <AccountActivateNotification
              requiredEmail={requiredEmail}
              clearEmail={() => {
                setRequiredEmail("");
              }}
            ></AccountActivateNotification>
          </Route>
          <Route path="/myBooks/estimatereview">
            <EstimateReview environment={environment}></EstimateReview>
          </Route>
          <Route path="/myBooks/applicationaccessapproval">
            <ApplicationAccessApproval
              environment={environment}
            ></ApplicationAccessApproval>
          </Route>
          <Route path="/myPlan/signup">
            {stage === 1 && (
              <SignUpMyPlan
                environment={environment}
                login={signInHandlerMyPlan}
                id_one_tap={id_one_tap}
                toast={showToast}
                onNext={onNextHandler}
                onDone={SignUpHandler}
                showToast={showToast}
                showLoader={showLoader}
                socialLogin={signUpData.socialLogin}
                email={signUpData.User.username}
                password={signUpData.User.password}
                validEmail={signUpData.User.username === "" ? false : true}
                validPassword={signUpData.User.password === "" ? false : true}
                clearData={clearData}
                User={signUpData.User}
                responseInvalidMessage={loginResponse.responseInvalidMessage}
                clearResponseData={() => {
                  setLoginResponse({
                    responseInvalid: false,
                    responseInvalidMessage: "",
                  });
                }}
                otpVerifiedSuccessfully={otpVerifiedSuccessfully}
                setOtpVerifiedSuccessfully={(flag) => {
                  setOtpVerifiedSuccessfully(flag);
                }}
              ></SignUpMyPlan>
            )}
            {stage === 2 && (
              <BusinessDetailsWizMyPlan
                clearFailMessage={() => {
                  setMessage("");
                }}
                Organization={signUpData.Organization}
                SetOrganisationData={SetOrganisationData}
                environment={environment}
                showLoader={showSignUpLoader}
                session_id={signUpPayload.session_id}
                redirect={redirect_Sign_Up_myPlan}
                signUpSuccess={signUpSuccess}
                username={signUpData.User.username}
                password={signUpData.User.password}
                onPrev={onPrevHandler}
                onDone={BusinessWizardHandlerMyPlan}
                failMessage={message}
              ></BusinessDetailsWizMyPlan>
            )}
          </Route>
          <Route path="/myPlan/login">
            <LoginMyPlan
              showLoader={showLoginLoader}
              environment={environment}
              id_one_tap={id_one_tap}
              signIn={signInHandlerMyPlan}
              onNext={onNextHandler}
              onDone={SignUpHandler}
              socialLogin={signUpData.User.socialLogin}
              responseInvalid={loginResponse.responseInvalid}
              responseInvalidMessage={loginResponse.responseInvalidMessage}
              setFalse={() => {
                setLoginResponse({
                  responseInvalid: false,
                  responseInvalidMessage: "",
                });
              }}
              email={signUpData.User.username}
              password={signUpData.User.password}
              clearData={clearData}
            ></LoginMyPlan>
          </Route>
          <Route path="/myPlan/forgotpassword">
            <ForgotPasswordMyPlan
              environment={environment}
              showToast={showSuccessToast}
            ></ForgotPasswordMyPlan>
          </Route>
          <Route path="/myPlan/resetuserpassword">
            <ResetuserpasswordMyPlan
              environment={environment}
              showSuccessToast={showSuccessToast}
              showFailureToast={showFailureToast}
            ></ResetuserpasswordMyPlan>
          </Route>
          <Route path="/myPlan/inviteduserpassword">
            <InvitedUserPasswordMyPlan
              environment={environment}
              showSuccessToast={showSuccessToast}
              showFailureToast={showFailureToast}
            ></InvitedUserPasswordMyPlan>
          </Route>
          <Route path="/myPlan/accountdelete">
            <AccountDeleteMyPlan
              environment={environment}
            ></AccountDeleteMyPlan>
          </Route>
          <Route path="/myPlan/accountactivation">
            <AccountActivationMyPlan
              environment={environment}
            ></AccountActivationMyPlan>
          </Route>
          <Route path="/myPlan/">
            <Redirect to="/myPlan/login"></Redirect>
          </Route>
          <Route path="/mybooks/">
            <Redirect to="/myBooks/login"></Redirect>
          </Route>
          <Route path="/myplan/">
            <Redirect to="/myPlan/login"></Redirect>
          </Route>
          <Route path="/">
            <Redirect to="/myBooks/login"></Redirect>
          </Route>
        </Switch>
      </BrowserRouter>
    </>
  );
}

export default App;
